import { formatNumber } from '@/lib/utils'

export default {
    methods: {
        formatNumber(number) {
            return formatNumber(number)
        },
    },
}
